/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { StorageKeys } from 'utils/local-storage';

import { DOMAINS, LANGUAGES, REGIONS } from './types';

export const LOCALE_SELECTED_QUERY_PARAM = 'locale-selected';

export const regionSpecificLocalStorageKeys = [
  StorageKeys.STORE,
  StorageKeys.AUTH_REDIRECT,
  StorageKeys.ORDER,
  StorageKeys.SERVICE_MODE,
];

export const READABLE_LANGUAGES = {
  [LANGUAGES.de]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
  [LANGUAGES.en]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
  [LANGUAGES.fr]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
  [LANGUAGES.it]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
  [LANGUAGES.ko]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
  [LANGUAGES.nl]: {
    [LANGUAGES.de]: 'Deutsch',
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.ko]: '한국어 (韓國語), 조선어 (朝鮮語)',
    [LANGUAGES.nl]: 'Nederlands, Vlaams',
  },
};

export const REGION_DOMAIN_VALUES = {
  AQ: DOMAINS.aq,
  CA: DOMAINS.ca,
  CH: DOMAINS.ch,
  DE: DOMAINS.de,
  GB: DOMAINS.uk,
  KR: DOMAINS.kr,
  NL: DOMAINS.nl,
  NZ: DOMAINS.nz,
  US: DOMAINS.com,
  ZA: DOMAINS.za,
};

/* @TODO: let's just use formatMessage here instead of redefining for every language */
export const READABLE_REGIONS = {
  [LANGUAGES.en]: {
    [REGIONS.CA]: 'Canada',
    [REGIONS.GB]: 'Great Britain',
    [REGIONS.US]: 'USA',
    [REGIONS.ZA]: 'South Africa',
    [REGIONS.CH]: 'Switzerland',
    [REGIONS.DE]: 'Germany',
    [REGIONS.NZ]: 'New Zealand',
  },
  [LANGUAGES.fr]: {
    [REGIONS.ZA]: 'Afrique du Sud',
    [REGIONS.CA]: 'Canada',
    [REGIONS.US]: 'États Unis',
    [REGIONS.GB]: 'Grande Bretagne',
    [REGIONS.CH]: 'Switzerland',
    [REGIONS.DE]: 'Allemagne',
    [REGIONS.NZ]: 'Nouvelle-Zélande',
  },
  [LANGUAGES.de]: {
    [REGIONS.CA]: 'Kanada',
    [REGIONS.GB]: 'Großbritannien',
    [REGIONS.US]: 'Vereinigte Staaten von Amerika',
    [REGIONS.ZA]: 'Südafrika',
    [REGIONS.CH]: 'Schweiz',
    [REGIONS.DE]: 'Deutschland',
    [REGIONS.NZ]: 'Neuseeland',
  },
  [LANGUAGES.it]: {
    [REGIONS.CA]: 'Canada',
    [REGIONS.GB]: 'Gran Bretagna',
    [REGIONS.US]: 'Stati Uniti',
    [REGIONS.ZA]: 'Sud Africa',
    [REGIONS.CH]: 'Svizzera',
    [REGIONS.DE]: 'Germania',
    [REGIONS.NZ]: 'Nuova Zelanda',
  },
};
